import DisplayAdOutbrain from '@/components/Advertising/Outbrain/Outbrain'
import styles from './AdSlot.module.scss'
import AppContext from '@/types/context'

type WidgetAdSlotObProps = {
  readonly model: {
    readonly outbrainId?: string
  }
}

const AdslotOutbrain = ({ item, context }: { item: WidgetAdSlotObProps; context: AppContext }) => (
  <>
    {item.model.outbrainId && (
      <DisplayAdOutbrain obId={item.model.outbrainId} className={styles.wrapper} cookies={context.cookies} />
    )}
  </>
)

export default AdslotOutbrain
